import React, { Component } from 'react'
import { Link } from 'react-router'
import { connect } from 'react-redux'

import { FILE_STORAGE } from '../../../constants'

// actions
import { setEmbeddedBookingContactInfo, saveEmbeddedBooking } from '../../../actions/embeddedbooking'

// utils
import { translation } from '../../../utils/helpers'
import { renderDate } from '../../../utils/time'

// Icons
import { EmbeddedBookingIcons } from '../../../shared/elements/icons'
import Icon from '../../../shared/elements/icon'

// Components
import Gallery from '../../../shared/components/Gallery'

// Elements
import Button from '../../../shared/elements/button'
import Check from '../../../shared/elements/check'

import './sendview.scss'

class SendView extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isSent: false,
      consent: false,
      inviteToPortal: true,
      busy: false
    }
  }

  renderStepHeader (stepId, title) {
    return (
      <div className='step-header'>
        <div className='step-title'>
          <div>{title}</div>
          {!this.props.EmbeddedBooking.IsComplete && (
            <div onClick={(e) => this.props.onNavClick(e, stepId)}>
              <Icon
                size='s'
                icon={EmbeddedBookingIcons.Edit_Pencil}
                injectSvg
              />
            </div>
          )}
        </div>
      </div>
    )
  }

  renderStep1 () {
    // Photos
    let images = this.props.EmbeddedBooking.FilesInfo.Files.filter(x => x.IsImage)

    let stepId = 1
    return (
      <div className='__content'>
        <div className='step-circle-large active'>
          <span>{stepId}</span>
        </div>
        {this.renderStepHeader(stepId, translation(16685))}
        <div className='section section__photos'>
          <Gallery files={images} renderImage={this.renderImage} />
        </div>
      </div>
    )
  }

  renderStep2 () {
    // CarData
    let carData = this.props.EmbeddedBooking.CarData
    let brand = this.props.Brands.filter(x => x.Id === carData.BrandNameId)[0]
    if (brand.Name === '2000') brand = { Id: 2000, Name: translation(2000) }

    let stepId = 2
    return (
      <div className='__content'>
        <div className='step-circle-large active'>
          <span>{stepId}</span>
        </div>
        {this.renderStepHeader(stepId, translation(77))}
        <div className='section section__cardata'>
          <div>
            <div>{translation(16693)}</div>
            <div>{carData.Km}</div>
          </div>
          {this.props.flowType === 'with_regnr' &&
          <div>
            <div>{translation(78)}</div>
            <div>{carData.RegNumber}</div>
          </div>}
          <div>
            <div>{translation(145)}</div>
            <div>{brand.Name}</div>
          </div>
          <div>
            <div>{translation(146)}</div>
            <div>{carData.Model}</div>
          </div>
          <div>
            <div>{translation(81)}</div>
            <div>{carData.ChassisNumber}</div>
          </div>
          <div className='descriptionBox'>
            <div>{translation(16686)}</div>
            <div>{carData.DamageComment}</div>
          </div>
        </div>
      </div>
    )
  }

  renderStep3 () {
    // OtherInfo
    let otherInfo = this.props.EmbeddedBooking.OtherInfo
    let insuranceCompany = { Company: '' }
    if (otherInfo.InsuranceCompanyId !== null && this.props.EmbeddedBooking.InsuranceCompanies !== undefined && this.props.EmbeddedBooking.InsuranceCompanies !== null) {
      insuranceCompany = this.props.EmbeddedBooking.InsuranceCompanies.filter(x => x.InsuranceCompanyId === otherInfo.InsuranceCompanyId)[0]
    }

    const renderInsuranceOrderCompany = () => {
      return (
        <div>
          <div>{translation(418)}</div>
          <div>{insuranceCompany.Company}</div>
        </div>
      )
    }
    const renderInsuranceOrderDamageNr = () => {
      return (
        <div>
          <div>{translation(16688)}</div>
          <div>{otherInfo.DamageNr}</div>
        </div>
      )
    }
    const renderInsuranceOrderDamageDate = () => {
      return (
        <div>
          <div>{translation(18322)}</div>
          <div>{renderDate(otherInfo.DamageDate)}</div>
        </div>
      )
    }
    const renderRentalCar = () => {
      return (
        <div>
          <div>{translation(16689)}</div>
          <div>{otherInfo.NeedRental === true ? translation(47).toUpperCase() : translation(48).toUpperCase()}</div>
        </div>
      )
    }

    let stepId = 3
    return (
      <div className='__content'>
        <div className='step-circle-large active'>
          <span>{stepId}</span>
        </div>
        {this.renderStepHeader(stepId, translation(16687))}
        <div className='section section__otherinfo'>
          {renderInsuranceOrderCompany()}
          {renderInsuranceOrderDamageNr()}
          {renderInsuranceOrderDamageDate()}
          {renderRentalCar()}
        </div>
      </div>
    )
  }

  renderStep4 () {
    // ContactInfo
    let contact = this.props.EmbeddedBooking.ContactInfo
    let stepId = 4
    return (
      <div className='__content'>
        <div className='step-circle-large active'>
          <span>{stepId}</span>
        </div>
        {this.renderStepHeader(stepId, translation(16691))}
        <div className='section section__contactinfo'>
          <div>
            <div>{translation(16606)}</div>
            <div>{contact.ContactName}</div>
          </div>
          <div>
            <div>{translation(16607)}</div>
            <div>{contact.ContactLastName}</div>
          </div>
          <div>
            <div>{translation(25)}</div>
            <div>{contact.Address}</div>
          </div>
          <div>
            <div>{translation(16791)}</div>
            <div>{contact.ZipCode}</div>
          </div>
          <div>
            <div>{translation(37)}</div>
            <div>{contact.City}</div>
          </div>
          <div>
            <div>{translation(38)}</div>
            <div>{contact.ContactPhone}</div>
          </div>
          <div>
            <div>{translation(1052)}</div>
            <div>{contact.ContactEmail}</div>
          </div>
        </div>
      </div>
    )
  }

  renderCompleted () {
    let text = this.props.EmbeddedBooking.CompletionText
    if (typeof text !== 'string') {
      text = ''
    }
    let lines = text.split('\n')
    return (
      <div className='send__view completed'>
        <div className='top completed'>
          {this.props.children}
        </div>
        <div className='content'>
          <h1>{translation(16706)}</h1>
          <div className='text'>
            {lines.map((l, i) => <p key={'l_' + i}>{l}</p>)}
          </div>
          <Button style='primary' labelText={956} onClick={(e) => this.props.onNavClick(e, 'restart')} />
        </div>
      </div>
    )
  }

  renderImage (image, index) {
    const url = FILE_STORAGE + image.ThumbURL
    const fullUrl = FILE_STORAGE + image.FileURL
    return (
      <div className='image-div' key={index}>
        <a href={fullUrl} data-lightbox='gallery' data-title={image.FileName}><img src={url} /></a>
      </div>
    )
  }

  render () {
    if (this.props.EmbeddedBooking.IsComplete === true) {
      let link = document.getElementById('booking-portal-link')
      if (link.href) {
        link.click()
        return null
      } else {
        return this.renderCompleted()
      }
    }
    // } else {
    //   return (
    //     <div className='send__view full-width'>
    //       <Panel title={16690}>
    //         <div className='send__content'>
    //           {this.renderStep1()}
    //           {this.renderStep2()}
    //           {this.renderStep3()}
    //           {this.renderStep4()}
    //           {!this.props.EmbeddedBooking.IsComplete && (
    //             <div className='actions'>
    //               <div className='consent-box'>
    //                 <Check simple name='Consent' onChange={() => this.setState({ consent: !this.state.consent })} checked={this.state.consent} />
    //                 <div className='consent-text'>
    //                   <div className='consent-text__text'>{translation(16727)}
    //                     {this.props.EmbeddedBooking.PrivacyPolicyUrl &&
    //                       <Link to={{ pathname: this.props.EmbeddedBooking.PrivacyPolicyUrl }} className='link' target='_blank'>{' ' + translation(16728)}</Link>}
    //                   </div>
    //                 </div>
    //               </div>
    //               <div className='buttons'>
    //                 <div className='back-button'>
    //                   <Button style='secondary' labelText={translation('394')} onClick={(e) => this.props.onNavClick(e, 'previous')} />
    //                 </div>
    //                 <Button spacing={0} labelText={16703} disabled={!this.state.consent} onClick={(e) => this.props.onNavClick(e, 'complete')} />
    //               </div>
    //             </div>
    //           )}
    //         </div>
    //       </Panel>
    //     </div>
    //   )
    // }
    // if (this.props.EmbeddedBooking.IsComplete === true) return this.renderCompleted()

    const renderConsent = () => {
      return (
        <div className='consent-box'>
          <Check simple name='Consent' onChange={() => this.setState({ consent: !this.state.consent })} checked={this.state.consent} />
          <div className='consent-text'>
            <div className='consent-text__text'>{translation(16727)}
              {this.props.EmbeddedBooking.PrivacyPolicyUrl && <Link to={{ pathname: this.props.EmbeddedBooking.PrivacyPolicyUrl }} className='link' target='_blank'>{' ' + translation(16728)}</Link>}
            </div>
          </div>
        </div>
      )
    }
    const renderInvite = () => {
      if (!this.props.EmbeddedBooking.IsCarOwnerPortalAvailable) {
        return null
      }
      return (
        <div className='invite-box'>
          <Check simple name='Invite' onChange={() => this.saveChanges({InviteToPortal: !this.props.EmbeddedBooking.InviteToPortal})} checked={this.props.EmbeddedBooking.InviteToPortal} />
          <div className='invite-text'>
            <div className='invite-text__text'>{translation(19013)}</div>
          </div>
        </div>
      )
    }

    const renderActions = () => {
      const onClickPrevious = (e) => {
        this.setState({busy: true})
        this.props.onNavClick(e, 'previous').then(() => {
          this.setState({busy: false})
        })
      }

      const onClickComplete = (e) => {
        this.setState({busy: true})
        this.props.onNavClick(e, 'complete').then(() => {
          this.setState({busy: false})
        })
      }

      return (
        <section className='bottom'>
          {renderConsent()}
          {renderInvite()}
          <div className='ctaWrapper'>
            <Button style='secondary' labelText={translation(394)} disabled={this.state.busy} onClick={onClickPrevious} leftChildren >
              <Icon size='s' icon={EmbeddedBookingIcons.Left_Arrow} injectSvg />
            </Button>
            <Button style='primary' spacing={0} labelText={translation(752)} disabled={!this.state.consent || this.state.busy} onClick={onClickComplete}>
              <Icon size='s' icon={EmbeddedBookingIcons.Right_Arrow} injectSvg />
            </Button>
          </div>
        </section>
      )
    }
    return (
      <div className='send__view'>
        <section className='top'>
          <h1>{translation(16703)}</h1>
          {this.props.children}
        </section>
        <section className='middle'>
          {this.renderStep1()}
          {this.renderStep2()}
          {this.renderStep3()}
          {this.renderStep4()}
        </section>
        {!this.props.EmbeddedBooking.IsComplete && renderActions()}
      </div>
    )
  }

  saveChanges (newData) {
    let data = {...this.props.EmbeddedBooking, ...newData}
    this.props.saveEmbeddedBooking(data)
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    Brands: state.common.brands,
    EmbeddedBooking: state.embeddedbooking
  }
}

export default connect(mapStateToProps, { setEmbeddedBookingContactInfo, saveEmbeddedBooking })(SendView)



// WEBPACK FOOTER //
// ./src/app/pages/EmbeddedBooking/SendView/index.js